import { Fragment } from 'react';
import addPhoto from '~/assets/icons/add_photo.svg';
import { ImgIcon } from '~/components/ui/ImgIcon';
import {
	StyledContainer,
	StyledImage,
	StyledUrlText,
} from './PhotoItem.styled';

const DIRECT_IMAGE_EXT = /\.(jpg|jpeg|png|gif|webp|bmp)(\?|$)/i;
const DIRECT_IMAGE_CDN = /^https?:\/\/(i\.imgur\.com|i\.ibb\.co)/i;

const isDirectImageUrl = (url: string): boolean =>
	url.startsWith('data:image') ||
	DIRECT_IMAGE_EXT.test(url) ||
	DIRECT_IMAGE_CDN.test(url);

const PhotoItem = ({
	photo,
	onClick,
}: {
	photo: string;
	onClick?: () => void;
}) => {
	const empty = !photo?.trim();
	const directImage = !empty && isDirectImageUrl(photo);

	return (
		<StyledContainer $empty={empty} $url={directImage} onClick={onClick}>
			{empty && <ImgIcon icon={addPhoto} width={20} height={20} />}
			{directImage && <StyledImage src={photo} alt="" />}
			{!empty && !directImage && (
				<Fragment>
					<ImgIcon icon={addPhoto} width={20} height={20} />
					<StyledUrlText title={photo}>{photo}</StyledUrlText>
				</Fragment>
			)}
		</StyledContainer>
	);
};

export { PhotoItem };
